module.exports = __webpack_public_path__ + "static/gh-5-b70ffdb375e5f6590a005855cded370d.jpg";